// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"Modal_noScrolling__t20Rv","overlay":"Modal_overlay__GT37E","wrapper":"Modal_wrapper__V0TP3","close":"Modal_close__Q48kk","closeIcon":"Modal_closeIcon__Tmn8D"};